<template>
  <a href="#" class="bg-white hover:bg-blue-50 rounded-md shadow-md p-3 flex">
    <div class="w-full text-center" style="width: 100px">
      <!-- todo translate-->
      <ui-pictogram size="xl" title="Karel Drašnar">KD</ui-pictogram>
    </div>
    <div class="text-sm pl-5 space-y-1 flex-grow">
      <div class="flex justify-between">
        <h3 class="font-bold"><span class="text-white bg-bc-blue px-1">BrandCloud</span></h3>
        <span>
                    <aw-icon icon="comment-empty" class="w-5 h-5 " />
                  </span>
      </div>
      <div class="text-gray-400">Brancloud / Storage / Some other path</div>
      <div>
        Tenhle web je naprosto boží!!!
      </div>
    </div>
  </a>
</template>